import { createFileRoute, Navigate } from "@tanstack/react-router"
import { CustomerListSearchSchema } from "./list/route"

export const Route = createFileRoute("/_base/_auth/customers/")({
  component: RouteComponent,
})

function RouteComponent() {
  return <Navigate to="/customers/list" search={CustomerListSearchSchema.parse({})} replace />
}
